import {useStore} from "vuex";
import {computed} from "vue";

const useActiveTab = () => {
  const store = useStore();
  const activeTab = computed(() => store.getters['backlinkOpportunity/activeTab']);

  const isTabOpportunities = computed(() => activeTab.value === 'opportunities');
  const isTabInProgress = computed(() => activeTab.value === 'in-progress');
  const isTabCompleted = computed(() => activeTab.value === 'completed');
  const isTabRemoved = computed(() => activeTab.value === 'removed');

  return {
    isTabOpportunities,
    isTabInProgress,
    isTabCompleted,
    isTabRemoved
  };
};

export default useActiveTab;
